export const Role = {
    Admin: "ADMIN",
    SuperUser: "SUPERUSER",
    User: "USER",
}

export const CompanyRole = {
    Manufacturer: "Manufacturer",
    Owner: "Owner",
}